import Vue, { DirectiveOptions } from "vue";
import AppConsts from "@/lib/appconst";

import "normalize.css";
import ElementUI from "element-ui";
import SvgIcon from "vue-svgicon";

import "@/styles/element-variables.scss";
import "@/styles/index.scss";

import App from "@/app.vue";
import store from "@/store";
import router from "@/router";
import "@/icons/components";

import ajax from "@/lib/ajax";
import Util from "@/lib/util";
import { UserModule } from "@/store/modules/user";
import   {AesUtil} from "@/store/aes.utils";

import * as directives from "@/directives";
import * as filters from "@/filters";

import Viser from "viser-vue";

Vue.use(ElementUI, {
  size: "medium"
});
Vue.use(SvgIcon, {
  tagName: "svg-icon",
  defaultWidth: "1em",
  defaultHeight: "1em"
});

Vue.use(Viser);
Vue.prototype.$aes = AesUtil;

Object.keys(directives).forEach(key => {
  Vue.directive(key, (directives as { [key: string]: DirectiveOptions })[key]);
});

// Register global filter functions
Object.keys(filters).forEach(key => {
  Vue.filter(key, (filters as { [key: string]: Function })[key]);
});

Vue.config.productionTip = false;

if (!abp.utils.getCookieValue("Abp.Localization.CultureName")) {
  let language = navigator.language;
  abp.utils.setCookieValue(
    "Abp.Localization.CultureName",
    language,
    new Date(new Date().getTime() + 5 * 365 * 86400000),
    abp.appPath
  );
}

Vue.prototype.$http = ajax;

// 注入Url
let envName = "";
if (process.env.NODE_ENV === "production") {
  envName = "prod";
} else {
  envName = "dev";
}
let url = "/assets/appconfig." + envName + ".json";

ajax.get(url).then((result: any) => {
  AppConsts.remoteServiceBaseUrl = result.remoteServiceBaseUrl;
  AppConsts.appBaseUrl = result.appBaseUrl;
  AppConsts.idServerUrl = result.idServerUrl;

  ajax.defaults.baseURL = result.remoteServiceBaseUrl;
  ajax
    .get("sysadmin/AbpUserConfiguration/GetAll?v=" + new Date().getTime())
    .then(async data => {
      Util.abp = Util.extend(true, Util.abp, data);
      await UserModule.Init();
      new Vue({
        render: h => h(App),
        router,
        store: store,
        data: {
          currentPageName: ""
        },
        async mounted() {},
        created() {}
      }).$mount("#app");
    });
});
